import Grid from "@mui/material/Grid2";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";

const OperacionComercial = ({
  configuracion,
  handleChange,
  validation,
  tipoTranOptions,
  tipoImpOptions,
  tipoRegOptions,
  handleChangeSel,
}) => {
  return (
    <form>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                label="Timbrado"
                name="numtim"
                inputProps={{ maxLength: 8 }}
                value={configuracion.numtim}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.numtim}
                helperText={validation.numtim}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                type="date"
                label="Fecha de Inicio"
                name="fecinit"
                value={configuracion.fecinit}
                onChange={handleChange}
                onBlur={handleChange}
                InputLabelProps={{ shrink: true }}
                error={!!validation.fecinit}
                helperText={validation.fecinit}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <Divider sx={{ mt: 3, mb: 2 }}>Tipo de Transacción</Divider>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="tipotran-label">Tipo de Transacción</InputLabel>
                <Select
                  labelId="tipotran-label"
                  id="tipotran"
                  name="tipotran"
                  value={configuracion.tipotran}
                  label="Tipo de Transacción"
                  onChange={handleChangeSel}
                  onBlur={handleChangeSel}
                >
                  {tipoTranOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <Divider sx={{ mt: 3, mb: 2 }}>Tipo de Impuesto Afectado</Divider>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="tipoimp-label">
                  Tipo de impuesto afectado
                </InputLabel>
                <Select
                  labelId="tipoimp-label"
                  id="tipoimp"
                  name="tipoimp"
                  value={configuracion.tipoimp}
                  label="Tipo de impuesto afectado"
                  onChange={handleChangeSel}
                  onBlur={handleChangeSel}
                >
                  {tipoImpOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <Divider sx={{ mt: 3, mb: 2 }}>Tipo de Régimen</Divider>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="tiporeg-label">Tipo de Régimen</InputLabel>
                <Select
                  labelId="tiporeg-label"
                  id="tiporeg"
                  name="tiporeg"
                  value={configuracion.tiporeg}
                  label="Tipo de Régimen"
                  onChange={handleChangeSel}
                  onBlur={handleChangeSel}
                >
                  {tipoRegOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Divider sx={{ mt: 3, mb: 2 }}>Datos del Responsable</Divider>
        </Grid>
        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 6, sm: 6, md: 3 }}>
              <TextField
                fullWidth
                label="Número de documento"
                name="numidresp"
                value={configuracion.numidresp}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.numidresp}
                helperText={validation.numidresp}
              />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="tipoidresp-label">Tipo de documento</InputLabel>
                <Select
                  labelId="tipoidresp-label"
                  id="tipoidresp"
                  name="tipoidresp"
                  value={configuracion.tipoidresp}
                  label="Tipo de documento"
                  onChange={handleChange}
                  onBlur={handleChange}
                >
                  <MenuItem value="1">Cédula paraguaya</MenuItem>
                  <MenuItem value="2">Pasaporte</MenuItem>
                  <MenuItem value="3">Cédula extranjera</MenuItem>
                  <MenuItem value="4">Carnet de residencia</MenuItem>
                  <MenuItem value="9">Otro</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 3 }}>
              <TextField
                fullWidth
                label="Nombre"
                name="nomresp"
                value={configuracion.nomresp}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.nomresp}
                helperText={validation.nomresp}
              />
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 3 }}>
              <TextField
                fullWidth
                label="Cargo"
                name="cargresp"
                value={configuracion.cargresp}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.cargresp}
                helperText={validation.cargresp}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default OperacionComercial;
